export enum HybridClassEventType {
  HYBRID_CLASS_CLOSE_EVENT = 'hybrid_class_close_event',
  HYBRID_CLASS_TRACKING_EVENT = 'hybrid_class_tracking_event',
}



// WEBPACK FOOTER //
// ./ts/app/hybrid-classes/hybrid-classes-events.ts